import { Component, Input } from '@angular/core';
import { BuyersEditCardDialogComponent } from 'src/app/buyers/buyers-edit-card-dialog/buyers-edit-card-dialog.component';
import { BuyersEditIbanDialogComponent } from 'src/app/buyers/buyers-edit-iban-dialog/buyers-edit-iban-dialog.component';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';
import { StripePaymentSource } from 'src/app/core/stripe-payment-sources.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-order-details-general-payment',
  templateUrl: './order-details-general-payment.component.html',
  styleUrls: ['./order-details-general-payment.component.scss'],
})
export class OrderDetailsGeneralPaymentComponent {
  @Input() order?: Order;

  constructor(
    private readonly utils_service: UtilsService,
    private readonly dialog_service: DialogService,
    private readonly error_service: ErrorService,
  ) {}

  getCardSource(): StripePaymentSource | undefined {
    return this.order?.origin_buyer_stripe_payment_source || this.order?.buyer_stripe_payment_source;
  }

  getCardLogo(funding?: string): string {
    let prefix = '../../assets/img/payment_methods/';
    switch (funding) {
      case 'mastercard':
        return prefix + 'mastercard-logo.png';
      case 'visa':
        return prefix + 'visa-logo.png';
      case 'amex':
        return prefix + 'american-express-logo.png';
      default:
        return '';
    }
  }

  getCardExp(): string {
    const card = this.order?.buyer_stripe_payment_source?.stripe_card;
    if (card?.exp_month && card?.exp_year) {
      return `${card.exp_month}/${card.exp_year}`;
    }

    return '-';
  }

  getPaymentLink(): string {
    if (!this.order) return '-';

    if (this.order.short_url) {
      return this.order.short_url.replaceAll(' ', '%20');
    } else {
      return this.utils_service.getBuyerAppLinkFromOrder(this.order);
    }
  }

  hasIbanSource(): boolean {
    return !!this.order?.buyer_qinetic_payment_source?.buyer_qinetic_payment_source_id;
  }

  hasCardSource(): boolean {
    return !!this.order?.buyer_stripe_payment_source?.buyer_stripe_payment_source_id;
  }

  onEditIbanClick(): void {
    this.dialog_service
      .openDialog(BuyersEditIbanDialogComponent, {
        buyer_id: this.order?.buyer_id,
        buyer_qinetic_payment_source_id: this.order?.buyer_qinetic_payment_source?.buyer_qinetic_payment_source_id,
        iban: this.order?.buyer_qinetic_payment_source?.qinetic_sepa_debit?.iban,
        order_id: this.order?.order_id,
        store_id: this.order?.store_id,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result?.success && dialog_result?.payment_source && this.order) {
          this.order.buyer_qinetic_payment_source = dialog_result.payment_source;
        }

        if (dialog_result?.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onDeleteCardClick(): void {
    this.dialog_service
      .openDialog(BuyersEditCardDialogComponent, {
        buyer: {
          buyer_id: this.order?.buyer_id,
        },
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result?.success && this.order) {
          this.order.buyer_stripe_payment_source = undefined;
        }

        if (dialog_result?.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
